<template>
	<transition>
		<div class="modal-wrapper">
			<div @click="close" class="modal-mask"></div>
			<div v-if="isImageModal" class="modal-content-image">
                <button @click="close" class="modal-button-image--exit" aria-label="Stäng modal">
					<v-icon
						name="icon-close"
						size="xs"
					/>
				</button>
				<slot name="content" />
			</div>
			<div v-else class="modal-content modal-content--outer">
				<button @click="close" class="modal-button--exit" type="button">
					{{ windowWidth > 600 ? "Stäng" : "" }}
					<v-icon
						cssModifiers="c-application-appartment--scale"
						name="icon-close"
						size="s"
					/>
				</button>
				<div class="modal-content modal-content--inner">
					<slot name="content" />
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import VIcon from "../../components/icon/VIcon";

export default {
	name: "VModal",
	components: {
		VIcon
	},
	props: {
		close: {
			type: Function
		},
		isImageModal: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			windowWidth: window.innerWidth
		};
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener("resize", this.onResize);
		});
	},

	beforeDestroy() {
		window.removeEventListener("resize", this.onResize);
	},

	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		}
	}
};
</script>
